import { Branch } from 'models/branch'
import { CartType } from 'models/common'
import { Logistic, LogisticProject, LogisticStatus } from 'models/logistic'
import { PaginationParams } from 'models/pagination'
import { HistoryStatusObject } from 'models/status'

export enum LogisticReportType {
  DEFAULT = 'excel',
  BY_DAY = 'excel_by_day',
  BY_MONTHS = 'excel_by_months',
}

export interface LogisticCartSpecialist {
  full_name: string
  phone: string
  pk: string
}

export interface GetExecutorsResponse {
  id: number
  project: number
  user: LogisticCartSpecialist
}

export interface Deliverymen {
  id: number
  user: {
    full_name: string
    phone: string
  }
}
export interface CreateLogisticParams {
  client_full_name: Logistic['client_full_name']
  project: LogisticProject['id']
  cart_type: CartType
  pan: string
  // status?: LogisticStatus
  start_delivery: string
  end_delivery: string
  phone: string
  address: Logistic['address']
  cost: Logistic['cost']
  is_paid: Logistic['is_paid']
  coordinates: {
    type: string
    coordinates: [number, number]
  }
}
export interface EditLogisticParams
  extends Pick<
    Logistic,
    | 'address'
    | 'cost'
    | 'is_paid'
    | 'start_delivery'
    | 'end_delivery'
    | 'phone'
    | 'coordinates'
  > {
  project: LogisticProject['id']
}

export interface RepeatLogisticParams {
  address: Logistic['address']
  status: LogisticStatus.repeat
  start_delivery: string
  end_delivery: string
}

export interface AssignConsultantParams {
  consultant: string
  applications: number[]
}

export interface DenyLogistic {
  id: Logistic['id']
  body: {
    status: LogisticStatus
    branch: Branch['id']
  }
}

export interface LogisticShortObject {
  id: number
  barcode?: string
  emboss_date?: string
  client_full_name: string
  address: string
  status?: LogisticStatus
  author?: string
  card_type: string
  phone: string
  coordinates?: {
    type: string
    coordinates: [number, number]
  }
  anketa_file: string | null
}

export interface ProcessedLogisticObject {
  id: number
  barcode: string
  author: LogisticCartSpecialist
  client_full_name: string
  consultant: LogisticCartSpecialist
  status: LogisticStatus
  emboss_date: string
  cost: number
  is_paid: true
  project: LogisticProject
  address: string
  phone: string
  start_delivery: string
  end_delivery: string
  card_type: string
  comments?: Array<{
    id: number
    author: {
      pk: string
      phone: string
      full_name: string
    }
    text: string
    created_at: string
  }>
  branch?: Branch
  documents?: Array<{
    id: number
    file: string
    application: string
  }>
  status_list?: Array<HistoryStatusObject>
  coordinates?: {
    type: string
    coordinates: [number, number]
  }
  anketa_file: string | null
}

export interface AssignableConsultantsObject
  extends Pick<
    ProcessedLogisticObject,
    | 'id'
    | 'barcode'
    | 'address'
    | 'client_full_name'
    | 'cost'
    | 'end_delivery'
    | 'start_delivery'
  > {}

export interface GetLogisticParams extends PaginationParams {
  start_date?: string
  end_date?: string
  status?: LogisticStatus
  project?: string
  card_type?: string
  barcode?: string
  search?: string
}

export interface UpdateLogisticStatus {
  id: Logistic['id']
  body: {
    status: LogisticStatus
    comment: string
  }
}

export interface GeocodeAddress {
  place_id: number
  licence: string
  osm_type: string
  osm_id: number
  lat: number
  lon: number
  class: string
  type: string
  place_rank: number
  importance: number
  addresstype: string
  name: string
  display_name: string
  address: {
    road?: string
    town?: string
    county?: string
    state?: string
    postcode?: string
    country?: string
    country_code?: string
    [key: string]: string | undefined // для возможных дополнительных полей
  }
  boundingbox: [string, string, string, string]
}

export type GeocodeAddressResponse = Pick<
  GeocodeAddress,
  'display_name' | 'place_id'
>
